import { useMemo } from "react";
import * as Endpoint from "../../../endpoints";

import { getSgApiService } from "@/sg-core/services/ApiService";
import { getContextService } from "../../services/contextService";
import { useSelector } from "react-redux";
import { selectToken } from "../../auth/store/authSelectors";
import IFormDefinition from "../../interfaces/IFormDefinition";
import useSWR from "swr";

export type IUseFormTypeHook = (formDefinition: string | number) => {
    data: IFormDefinition | null;
    fetching: boolean;
}

export const useFormDefinition: IUseFormTypeHook = (formDefinition) => {
    const token = useSelector(selectToken) || "";
    const apiService = getSgApiService(token);
    apiService.setToken(token)
    const service = getContextService(apiService, Endpoint.havainnot);

    const fetcher = async (): Promise<IFormDefinition> => {

        const result = await service.getFormDefinitionCorrected(formDefinition);

        if (result.isFailure) {
            throw result.error;
        }
        if (!result.value || !result.value.schema) {
            throw Error("Schema is missing!");
        }
        const formSchema = { ...result.value };
        console.info("[useFormDefinition.fetcher]:", { raw: formSchema });
        return formSchema;
    };

    const cacheKey = "obaservation:formDefinition:" + formDefinition

    const { data, isValidating } = useSWR(
        cacheKey,
        fetcher,
        { suspense: true, revalidateOnFocus: false, revalidateOnMount: false }
    );

    const rawData = data ?? null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating
    }), [rawData, isValidating]);
};